import axios from "axios";
import { createClient } from "@supabase/supabase-js";

const SUPA_URL = process.env.REACT_APP_SUPABASE_URL;
const SUPA_KEY = process.env.REACT_APP_SUPABASE_PUBLISHABLE_KEY;

export const DEMO = process.env.REACT_APP_DEMO_MODE === "true";

export const supabase = !DEMO && SUPA_URL && SUPA_KEY
  ? createClient(SUPA_URL, SUPA_KEY, { auth: { persistSession: true, autoRefreshToken: true, detectSessionInUrl: true } })
  : null;

export const api = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api` });

api.interceptors.request.use(async (cfg) => {
  if (supabase) {
    const { data } = await supabase.auth.getSession();
    const t = data?.session?.access_token;
    if (t) cfg.headers.Authorization = `Bearer ${t}`;
  }
  return cfg;
});

export function errMsg(e, fallback = "Something went wrong") {
  const d = e?.response?.data?.detail;
  if (Array.isArray(d)) return d.map((x) => `${x.loc?.slice(-1)[0] ?? ""}: ${x.msg}`).join("; ");
  return d || e?.message || fallback;
}

export async function download(path, filename) {
  const r = await api.get(path, { responseType: "blob" });
  const url = URL.createObjectURL(r.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}

export const inr = (n) => (n == null ? "—" : new Intl.NumberFormat("en-IN", { maximumFractionDigits: 0 }).format(n));
export const ago = (iso) => {
  if (!iso) return "—";
  const s = (Date.now() - new Date(iso).getTime()) / 1000;
  if (s < 3600) return `${Math.max(1, Math.round(s / 60))}m ago`;
  if (s < 86400) return `${Math.round(s / 3600)}h ago`;
  return `${Math.round(s / 86400)}d ago`;
};
export const TASK_LABELS = {
  resume_extraction: "Resume extraction",
  job_matching: "Job matching",
  resume_tailoring: "Resume tailoring",
  ats_analysis: "ATS analysis",
  cover_letter: "Cover letters",
  recruiter_draft: "Recruiter drafts",
  quality_check: "Quality checking",
};
export const KIND_LABELS = { resume: "Tailored resume", cover_letter: "Cover letter", recruiter_email: "Recruiter email draft", ats_analysis: "ATS analysis" };
